// Import model
import { CustomerReview } from '../models/CustomerReview';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CustomerReview - handles JSON serialization and deserialization with type validation
 */
export class CustomerReviewSerializer {
  /**
   * Deserializes a JSON string into a CustomerReview instance
   */
  static deserialize(json: string): CustomerReview {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CustomerReview instance
   */
  static fromObject(obj: any): CustomerReview {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CustomerReview');
    }


    const instance: CustomerReview = {
      provider: obj['provider'] as string | undefined,
      rating: obj['rating'] as number | undefined,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      respondedOn: obj['respondedOn'] as string | undefined,
      leadId: obj['leadId'] as string | undefined,
      leadIdName: obj['leadId|Name'] as string | undefined,
      projectExternalId: obj['projectExternalId'] as string | undefined,
      projectExternalIdName: obj['projectExternalId|Name'] as string | undefined,
      role: obj['role'] as string | undefined,
      location: obj['location'] as any | undefined,
      locationDistance: obj['locationDistance'] as any | undefined,
      iconImage: obj['IconImage'] as any | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      isActive: obj['isActive'] as boolean | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      lastModifiedOn: obj['LastModifiedOn'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CustomerReview instances
   */
  static deserializeArray(json: string): CustomerReview[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CustomerReview instance to a JSON string
   */
  static serialize(instance: CustomerReview): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CustomerReview instance to a plain object
   */
  static toObject(instance: CustomerReview): any {
    return {
      'provider': instance.provider,
      'rating': instance.rating,
      'name': instance.name,
      'description': instance.description,
      'respondedOn': instance.respondedOn,
      'leadId': instance.leadId,
      'leadId|Name': instance.leadIdName,
      'projectExternalId': instance.projectExternalId,
      'projectExternalId|Name': instance.projectExternalIdName,
      'role': instance.role,
      'location': instance.location,
      'locationDistance': instance.locationDistance,
      'IconImage': instance.iconImage,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'isActive': instance.isActive,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'LastModifiedOn': instance.lastModifiedOn,
    };
  }

  /**
   * Serializes an array of CustomerReview instances to a JSON string
   */
  static serializeArray(instances: CustomerReview[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
